<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="col-md-6"><h6>Add New Users</h6></div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <br />
  <form [formGroup]="formData" #formDirective="ngForm" novalidate>
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-label class="label-input">Select Project </mat-label>
      </div>
      <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7">
        <mat-form-field>
          <mat-select
            formControlName="projectCtr"
            (selectionChange)="siteChange($event)"
            required
          >
            <mat-option>Select Project</mat-option>
            <mat-option
              *ngFor="let item of sites; let i = index"
              [value]="item.siteId"
              >{{ item.siteName }}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="isFieldHasError('projectCtr', 'required')"
            >Please Select Site</mat-error
          >
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-label class="label-input">NT ID </mat-label>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <mat-form-field>
          <input
            type="text"
            matInput
            formControlName="ntIDCtr"
            [(ngModel)]="user.ntID"
            name="ntID"
            placeholder="NT ID"
            required
          />
          <mat-error *ngIf="this.formData.get('ntIDCtr').hasError('required')"
            >This field is required!</mat-error
          >
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-label class="label-input">Email</mat-label>
      </div>
      <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7">
        <mat-form-field>
          <input
            type="email"
            matInput
            formControlName="emailCtr"
            [(ngModel)]="user.email"
            name="email"
            placeholder="Email*"
          />
          <mat-error *ngIf="this.formData.get('emailCtr').hasError('required')"
            >This field is required!</mat-error
          >
          <mat-error *ngIf="this.formData.get('emailCtr').hasError('email')"
            >Not valid email!</mat-error
          >
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-label class="label-input">Email Recipient Class</mat-label>
      </div>
      <div
        class="col-xs-1 col-sm-1 col-md-1 col-lg-1"
        *ngFor="let class of emailRecipientClass; let $index = index"
      >
        <mat-radio-button
          value="class"
          (change)="emailRecipientClassChange(class)"
          [checked]="$index === 0"
          >{{ class }}</mat-radio-button
        >
      </div>
    </div>

    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <mat-label class="label-input">Select Role of New User</mat-label>
      </div>
      <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7">
        <mat-form-field *ngIf="roles !== undefined">
          <mat-select [(ngModel)]="user.role" formControlName="roleCtr">
            <mat-option
              *ngFor="let item of roles | selectRoleFilter : user.site.siteName"
              value="{{ item.name }}"
              >{{ item.name }}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="error.role">{{ error.role }}</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        style="text-align: center"
      >
        <button
          type="button"
          id="clearbtn"
          bciprimarybutton
          class="button-primary"
          (click)="reset()"
          style="margin-right: 3px"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="submit icon"
              class="bosch-ic-refresh"
              style="width: max-content"
            ></mat-icon>
          </span>
          Clear Fields
        </button>
        &nbsp;
        <button
          type="button"
          id="addUser"
          bciprimarybutton
          class="button-primary"
          [disabled]="!formData.valid"
          (click)="save()"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="submit icon"
              class="bosch-ic-checkmark-frame"
              style="width: max-content"
            ></mat-icon>
          </span>
          Add User
        </button>
      </div>
    </div>
  </form>
</mat-expansion-panel>
